module.exports = __webpack_public_path__ + "images/dingtalk/topic-18dd096efb4d969648e118a530e1f70c.png";